// import React, { useState } from 'react';
import "./User.css";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { addUser, getUserById, updateUser } from "../../../redux/user/action";
import { addadmin } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import UploadImage from "../Category/UploadImage";
import AddUpdateHeader from "../../Common/CardHeader/AddUpdateHeader";
import { useParams } from "react-router-dom";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { fireStore } from "../../../Firebase/Config";
import { v4 as uuidv4 } from "uuid";
import swal from "sweetalert";
import UserAddress from "./UserAddress";
import CreateWallet from "../Wallet/CreateWallet";
import UserWallet from "./UserWallet";
import { usePermissions } from "../../../Hooks/usePermissions";
import { MENU, PERMISSION } from "../../../lib/permissions";

const uniqueId1 = uuidv4();
const formData = [
  { title: "First Name", name: "first_name" },
  { title: "Last Name", name: "last_name" },

  { title: "Mobile Number", name: "mobile_number" },
  { title: "Email Address (Optional)", name: "email_id" },
  // { title: "Gender", name: "gender" },
  { title: "Status", name: "status" },
];

const initialValues = {};

const SavedAddressList = ({ data }) => {
  const [activeTab, setActiveTab] = useState("editUser");
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const { t } = useTranslation();
  const { id } = useParams();
  // const [gender, setGender] = useState(1);
  const [profileimage, setProfileimage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(data?.update);
  const dispatch = useDispatch();
  const { hasAction } = usePermissions();
  const selectedUser = useSelector(({ user: { userbyid } }) => userbyid);
  console.log(selectedUser, "selectedUser");

  useEffect(() => {
    if (id) {
      dispatch(getUserById(id));
      setUpdate(true);
    }
  }, [id]);

  const initialValues = {
    ...formData.reduce((acc, field) => {
      acc[field.name] = selectedUser?.[field.name] || "";
      return acc;
    }, {}),
    mobile_number: selectedUser?.mobile_number || "",
    country_code: selectedUser?.country_code || "",
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: (value) => handelSubmit(value),
    validationSchema: addadmin(update),
  });

  const handleCountryCode = (value, data) => {
    formik.setFieldValue(
      "mobile_number",
      `${value.slice(data.dialCode.length)}`
    );
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };
  console.log("sai");

  const handelSubmit = async (values) => {
    setLoading(true);

    if (profileimage) {
      const storage = getStorage(fireStore);

      try {
        const uploadImage = async (file, path) => {
          if (file) {
            const imageRef = ref(storage, path);
            const uploadTask = uploadBytesResumable(imageRef, file);
            const snapshot = await uploadTask;
            return await getDownloadURL(snapshot.ref);
          }
          return "";
        };

        let maleImageUrl = "";

        if (profileimage) {
          maleImageUrl = await uploadImage(
            profileimage,
            `/Category/${uniqueId1}_male_${profileimage.name}`
          );
        }
        const { password, ...restValues } = values;
        const countryCodeLength = values?.country_code?.length || 0;
        const mobileNumberWithoutCountryCode =
          values?.mobile_number?.slice(countryCodeLength);
        console.log(
          mobileNumberWithoutCountryCode,
          "mobileNumberWithoutCountryCode"
        );

        const data = {
          ...restValues,
          id: id,
          // profile_image: maleImageUrl,
          mobile_number: mobileNumberWithoutCountryCode, // Use the sliced mobile number
          country_code: values?.country_code,
        };
        if (password) {
          data.password = password;
        }
        dispatch(updateUser(data, setLoading, navigate));
        setUpdate(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    } else {
      const { password, ...restValues } = values;
      const countryCodeLength = values?.country_code?.length || 0;
      const mobileNumberWithoutCountryCode =
        values?.mobile_number?.slice(countryCodeLength);

      const data = {
        ...restValues,
        id: id,
        mobile_number: values?.mobile_number, // Use the sliced mobile number
        country_code: values?.country_code,
      };
      if (password) {
        data.password = password;
      }

      dispatch(updateUser(data, setLoading, navigate));
      setUpdate(false);
    }
  };

  const isEditable = hasAction(MENU.USER, PERMISSION.EDIT); // make sure this is above your return/JSX

  console.log("isEditable:", isEditable);

  const navigate = useNavigate();
  console.log(formik.values, "values");
  console.log(formik.errors, "erros");
  console.log(initialValues, "initialValues");

  return (
    <div className="card-head order-card order-timing">
      <div
        className=" d-flex align-items-center mb-3 w-50 tab-btn-sec"
        style={{ columnGap: "10px" }}
      >
        <button
          onClick={() => handleTabClick("editUser")}
          className={`tab-button ${activeTab === "editUser" ? "active" : ""}`}
        >
          Update User
        </button>
        <button
          onClick={() => handleTabClick("report")}
          className={`tab-button ${activeTab === "report" ? "active" : ""}`}
        >
          User Address
        </button>
         <button
    onClick={() => handleTabClick("wallet")}
    className={`tab-button ${activeTab === "wallet" ? "active" : ""}`}
  >
    Wallet
  </button>
      </div>

      <div className="">
        {activeTab === "editUser" && (
          <div>
            {/* <AddUpdateHeader modal={"Update User"} list={"User List"} /> */}
            <div className="">
              <form onSubmit={formik.handleSubmit}>
                <div className=" row">
                  {formData.map((prop, key) => {
                    if (prop.title === "Mobile Number") {
                      return (
                        <div className=" col-md-4" key={key} >
                          <div className="form-group">
                            <label htmlFor={prop.name}>{t(prop.title)}</label>
                            <PhoneInput
                              disabled={!isEditable}
                              country={"in"}
                              value={
                                formik.values.mobile_number
                                  ? `${formik.values.country_code}${formik.values.mobile_number}`
                                  : ""
                              }
                              onChange={(phone, data) =>
                                handleCountryCode(phone, data)
                              }
                              onBlur={() =>
                                formik.setFieldTouched(prop.name, true)
                              }
                            />
                          </div>

                          {(formik.touched.mobile_number ||
                            formik.errors.mobile_number) && (
                              <p style={{ color: "red" }}>
                                {formik.errors.mobile_number}
                              </p>
                            )}
                        </div>
                      );
                    }
                    if (prop.name === "status") {
                      const options = [
                        { value: "1", label: t("Active") },
                        { value: "2", label: t("Inactive") },
                        { value: "4", label: t("Block") },
                      ];

                      return (
                        <div className=" col-md-4 form-group" key={key} >
                          <label>{t(prop.title)}</label>
                          <div>
                            <ReactSelect
                              // className='form-control'
                              isDisabled={!isEditable}
                              value={options.find(
                                (option) =>
                                  option.value == formik.values?.[prop.name]
                              )}
                              placeholder={t(prop.title)}
                              id={prop.name}
                              name={prop.name}
                              options={options}
                              onChange={(selectedOption) =>
                                formik.handleChange(prop.name)(
                                  selectedOption.value
                                )
                              }
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched[prop.name] &&
                              formik.errors[prop.name] && (
                                <div className="error">
                                  {t(formik.errors[prop.name])}
                                </div>
                              )}
                          </div>
                        </div>
                      );
                    }

                    if (prop.name === "password") {
                      return (
                        <div className=" col-md-4" key={key} >
                          <div className="form-group">
                            <label>Password</label>
                            <CustomInput
                              disabled={!isEditable}
                              value={formik.values?.[prop.name]}
                              placeholder={t(prop.title)}
                              id={prop.name}
                              name={prop.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              touched={formik.touched}
                              errors={formik.errors}
                            />
                          </div>
                        </div>
                      );
                    }

                    if (prop.name === "profile_image") {
                      return (
                        <UploadImage
                          files={profileimage}
                          setFiles={setProfileimage}
                          update={update}
                          prop={prop}
                          formik={formik}
                          isEditable={isEditable}
                        />
                      );
                    }
                    // if (prop.name === "gender") {
                    //   const options = [
                    //     { value: 1, label: t("Male") },
                    //     { value: 2, label: t("Female") },
                    //     { value: 3, label: t("Both") },
                    //   ];

                    //   return (
                    //     <Col key={key} xs={4}>
                    //       <label>{t(prop.title)}</label>
                    //       <div>
                    //         <ReactSelect
                    //           value={options.find(
                    //             (option) =>
                    //               option.value == formik.values?.[prop.name],
                    //           )}
                    //           placeholder={t(prop.title)}
                    //           id={prop.name}
                    //           name={prop.name}
                    //           options={options}
                    //           onChange={(option) => {
                    //             formik.setFieldValue("gender", option?.value);
                    //             setGender(option?.value);
                    //           }}
                    //           onBlur={formik.handleBlur}
                    //         />
                    //         {formik.touched[prop.name] &&
                    //           formik.errors[prop.name] && (
                    //             <div className="error">
                    //               {t(formik.errors[prop.name])}
                    //             </div>
                    //           )}
                    //       </div>
                    //     </Col>
                    //   );
                    // }
                    if (prop.name === "dob") {
                      return (
                        <div className=" col-md-4" key={key} >
                          <div className="form-group">
                            <label>{prop?.title}</label>
                            <CustomInput
                              value={formik.values?.[prop.name]}
                              placeholder={t(prop.title)}
                              id={prop.name}
                              name={prop.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              touched={formik.touched}
                              errors={formik.errors}
                              type="date"
                              disabled={!isEditable}
                            />
                          </div>
                        </div>
                      );
                    }
                    if (prop.name === "email_id") {
                      return (
                        <div className=" col-md-4" key={key} >
                          <div className="form-group">
                            <label>{prop?.title}</label>
                            <CustomInput
                              value={formik.values?.[prop.name]}
                              placeholder={t(prop.title)}
                              id={prop.name}
                              name={prop.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              touched={formik.touched}
                              errors={formik.errors}
                              disabled={!isEditable}
                            />
                          </div>
                          {formik.touched[prop.name] &&
                            formik.errors[prop.name] && (
                              <div className="error">
                                {t(formik.errors[prop.name])}
                              </div>
                            )}
                        </div>
                      );
                    }
                    return (
                      <div className=" col-md-4" key={key} >
                        <div className="form-group">
                          <label>{prop?.title}</label>
                          <CustomInput
                            disabled={!isEditable}
                            value={formik.values?.[prop.name]}
                            placeholder={t(prop.title)}
                            id={prop.name}
                            name={prop.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            touched={formik.touched}
                            errors={formik.errors}
                          />
                          {formik.touched[prop.name] &&
                            formik.errors[prop.name] && (
                              <div className="error">
                                {t(formik.errors[prop.name])}
                              </div>
                            )}
                        </div>
                      </div>
                    );
                  })}
                  <Col
                    md={12}
                    className="text-center my-3 d-flex align-items-center justify-content-between"
                  >
                    <button
                      className="back-btn"
                      disabled={loading}
                      onClick={() => navigate("/user")}
                      type="submit"
                    >
                      Back
                    </button>
                    {isEditable && (
                      <button
                        className="submit-btn"
                        disabled={loading}
                        type="submit"
                      >
                        {!loading ? "Update" : <Spinner />}
                      </button>
                    )}
                  </Col>
                </div>
              </form>
            </div>
          </div>
        )}
        {activeTab === "report" && (
          <div className="">
            <UserAddress userId={selectedUser?.id}></UserAddress>
          </div>
        )}
        {activeTab === "wallet" && (
    <div>
      <UserWallet defaultUserId={selectedUser?.id} />
    </div>
        )}
      </div>
    </div>
  );
};

export default SavedAddressList;
